/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Alter_HintInputs */



/**
* | output |
* | --- |
* | "Tap a player, then a seat to swap them or an empty seat to move them. Remove or add players to change who plays." |
*
* @param {Rounds_Alter_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_alter_hint = /** @type {((inputs?: Rounds_Alter_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Alter_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Touchez un joueur, puis un siège pour les échanger ou un siège vide pour le déplacer. Retirez ou ajoutez des joueurs pour changer qui joue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Toque un jugador y luego un asiento para intercambiarlos, o un asiento libre para moverlo. Quite o añada jugadores para cambiar quién juega.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Toque em um jogador, depois em um lugar para trocá-los ou em um lugar vazio para movê-lo. Remova ou adicione jogadores para mudar quem joga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tocca un giocatore, poi un posto per scambiarli o un posto libero per spostarlo. Togli o aggiungi giocatori per cambiare chi gioca.")
	return /** @type {LocalizedString} */ ("Tap a player, then a seat to swap them or an empty seat to move them. Remove or add players to change who plays.")
});